export const LABOUR_TYPE = {
  'Remove & Replace': 'RR',
  Repair: 'REP',
  Paint: 'PAINT',
  Mechanical: 'MEC',
  Miscellaneous: 'MISC'
};
